import React, {PureComponent} from "react"
import {Col, Row} from "react-bootstrap"

import {TenantWalletTopup} from "@irati/types"

import Container from "../styled/Container"
import Intro from "../../components/Tenant/TopUp/Intro"
import CardPaymentForm from "../../components/Tenant/CardPaymentForm"

interface Location {
  tenantWalletTopup: TenantWalletTopup
}

interface Props {
  location: Location
}

class TenantWalletCardPayment extends PureComponent<Props> {
  render() {
    const {tenantWalletTopup} = this.props.location
    return (
      <Container>
        <Row>
          <Col md={12} lg={6}>
            <Intro />
          </Col>
          <Col md={12} lg={6}>
            <CardPaymentForm tenantWalletTopup={tenantWalletTopup} />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default TenantWalletCardPayment
